import { useQuery } from '@apollo/client';

import GET_FEATURE_FLAG from './graphql/GetFeatureFlag.graphql';
import type { GetFeatureFlag } from './graphql/types/GetFeatureFlag';

type useFeatureFlagProps = {
  flag: string;
};

const useFeatureFlag = ({ flag }: useFeatureFlagProps) => {
  const { data, loading } = useQuery<GetFeatureFlag>(GET_FEATURE_FLAG, {
    variables: { key: flag },
    fetchPolicy: 'network-only',
  });

  return {
    isActive: data?.featureFlag?.isActive || false,
    isLoading: loading,
  };
};

export default useFeatureFlag;
